import { IModalInfo } from "../interfaces/modal-info.interface";

export const GENERAL_ERR_001: IModalInfo = {
    icon: 'reject',
    title: 'Proceso bloqueado',
    text: `Para proteger tu seguridad, hemos bloqueado el proceso. </br>
     Para continuar, por favor comunícate con nuestro Contact Center a través de cualquiera de estos canales: </br></br>
     <strong>WhatsApp:</strong> +507 6774-0039</br>
     <strong>Correo electrónico:</strong> <a href="mailto:scliente@towerbank.com" target="_blank">scliente@towerbank.com</a><br>
     <strong>Teléfonos:</strong> +507 269-6900 o 800-6900
     `,
    text_button: 'Entendido',
    text_extra: 'Nuestro equipo estará listo para ayudarte a retomar el proceso.',
    type: 'message'
}

export const GENERAL_ERR_002: IModalInfo = {
    icon: 'reject',
    title: 'Error en el servicio',
    text: 'Ha ocurrido un problema con nuestro servidor y no pudimos procesar tu solicitud en este momento. </br> Por favor, intenta nuevamente en unos minutos. Si el problema persiste, contáctanos a través de nuestro <strong>WhatsApp:</strong> +507 6774-0039 o <strong>correo electrónico:</strong> <a href="mailto:scliente@towerbank.com" target="_blank">scliente@towerbank.com</a>',
    type: 'basic'
}